import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'
import get from 'lodash/get'
import moment from '../../lib/moment.js'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  authAction,
  lobAction,
  companyAction,
  modalAction,
  employeeAction,
} from './../../actions/'
import {
  authSelector,
  lobSelector,
  companySelector,
  modalSelector,
  employeeSelector,
} from './../../selectors'
import { searchLOBs } from '../../function'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditLOB from './edit'
import ListLOB from './list'
import LOBForm from '../../components/lob'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'

class LOBPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      id: '',
      span: false,
      lob: '',
      lob_code: '',
      company_id: '',
      start_date: '',
      search: '',
      defaultLOBs: [],
      LOBs: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleLOBLead = this.handleLOBLead.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.createEmployeeList = this.createEmployeeList.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.listEmployee(access_token)
    this.props.listCompany(access_token)
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'lobList') && this.state.search === '') {
      this.setState({
        LOBs: _.get(nextProps, 'lobList'),
        defaultLOBs: _.get(nextProps, 'lobList'),
      })
    }
    if (_.get(nextProps, 'lobCreate.lobCreate')) {
      this.props.showModal(
        'lob',
        _.get(nextProps, 'lobCreate.status'),
        _.get(nextProps, 'lobCreate.message')
      )
      this.props.listLOB(localStorage.getItem('access_token'))
      this.props.resetCreateLOB()
    }
    if (_.get(nextProps, 'lobEdit.lobEdit')) {
      this.setState({
        edit: false,
      })
      this.props.showModal(
        'lob',
        _.get(nextProps, 'lobEdit.status'),
        _.get(nextProps, 'lobEdit.message')
      )
      if (_.get(nextProps, 'lobEdit.status') === 200) this.showSave()
      this.props.listLOB(localStorage.getItem('access_token'))
      this.props.resetEditLOB()
      this.handleClickEdit(false, '')
    }
    if (_.get(nextProps, 'lobDeactivate.lobDeactivate')) {
      this.props.showConfirm(
        'deleteLOB',
        _.get(nextProps, 'lobDeactivate.status'),
        _.get(nextProps, 'lobDeactivate.message')
      )
      this.props.listLOB(localStorage.getItem('access_token'))
      this.props.resetDeactivateLOB()
    }
    if (_.get(nextProps, 'exportURL')) {
      window.open(_.get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportLOB()
    }
  }
  handleClickSearch() {
    this.setState({ LOBs: _.get(this.state, 'defaultLOBs').filter(searchLOBs, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ LOBs: _.get(this.state, 'defaultLOBs'), search: '' })
    else this.setState({ search: e.target.value })
  }
  createEmployeeList() {
    const object = _.get(this.props, 'employeeList')
    const temp = []
    if (object) {
      object.map((ob) => {
        if (!_.get(ob, 'is_init_user') && _.get(ob, '_id') !== localStorage.getItem('_id')) {
          temp.push({
            label: `${_.get(ob, 'first_name')} ${_.get(ob, 'last_name')}`,
            value: _.get(ob, '_id'),
          })
        }
        return ob
      })
    }
    return temp
  }
  handleClickEdit(editLOB, lob_id) {
    this.setState({
      edit: editLOB,
      id: lob_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleLOBLead(e) {
    const temp = []
    e.map((lead) => {
      temp.push({ id: lead.value })
      return lead
    })
    return temp
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your LOB information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('lobForm')
  }
  cancelForm() {
    this.props.hideModal('lobForm')
  }
  cancelAlert() {
    this.props.hideModal('lob')
  }
  submitForm() {
    this.props.createLOB(
      {
        lob_code: this.state.lob_code,
        name: this.state.lob,
        company_id: _.get(this.state, 'company_id') === '' ? _.get(this.props, 'listCompanyData')[0]._id : _.get(this.state, 'company_id'),
        start_date: this.state.start_date === '' ? '' : moment(this.state.start_date),
      },
      localStorage.getItem('access_token'))
  }

  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectLOB.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectLOB.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    const button = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonOK = (
      <div>
        <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetchingCompany')
    || get(this.props, 'getIsFetchingEmployee')
    || get(this.props, 'getIsFetchingLOB')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          export={ () => this.props.exportLOB(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          _.get(this.props, 'modalType') === 'lob' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ _.get(this.props, 'modalType') === 'lob' }
              type={ _.get(this.props, 'modalStatus') }
              message={ _.get(this.props, 'modalMessage') }
            />
        }
        {
          _.get(this.props, 'confirmType') === 'confirmSave' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'confirmSave' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }        {
          _.get(this.props, 'confirmType') === 'deleteLOB' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'deleteLOB' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        <Row noGutters>
          <Col>
            <ListLOB
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              LOBs={ this.state.LOBs }
              table={ 6 }
            />
          </Col>
          {
            this.state.span && <Col>
              <EditLOB
                edit={ this.state }
                employeeList={ this.createEmployeeList() }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ _.get(this.props, 'confrimType') }
                confirmStatus={ _.get(this.props, 'confirmStatus') }
                confirmType={ _.get(this.props, 'confirmType') }
                confirmMessage={ _.get(this.props, 'confirmMessage') }
              />
            </Col>
          }
        </Row>
        <Modal isOpen={ _.get(this.props, 'modalType') === 'lobForm' } toggle={ this.cancelForm }>
          <LOBForm
            create={ true }
            list={ _.get(this.props, 'listCompanyData') }
            employeeList={ this.createEmployeeList() }
            lob_code={ this.state.lob_code }
            lob={ this.state.lob }
            company_id={ this.state.company_id }
            lob_leaders={ this.state.lob_leaders }
            start_date={ this.state.start_date }
            button={ button }
            confirm={ _.get(this.props, 'modalType') }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            handleInput={ this.handleInput }
            handleLOBLead={ (e) => this.setState({ lob_leaders: e }) }
            cancelForm={ this.cancelForm }
            modalStatus={ _.get(this.props, 'modalStatus') }
            modalType={ _.get(this.props, 'modalType') }
          />
        </Modal>
      </Wrapper>
    )
  }
}

LOBPage.propTypes = {
  createLOB: PropTypes.func.isRequired,
  resetCreateLOB: PropTypes.func.isRequired,
  listCompany: PropTypes.func.isRequired,
  listEmployee: PropTypes.func.isRequired,
  listLOB: PropTypes.func.isRequired,
  resetEditLOB: PropTypes.func.isRequired,
  resetDeactivateLOB: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  redirectAuth: authSelector.redirectAuth,
  redirectLOB: lobSelector.redirectLOB,
  getIsFetchingCompany: companySelector.getIsFetching,
  getIsFetchingEmployee: employeeSelector.getIsFetching,
  getIsFetchingLOB: lobSelector.getIsFetching,
  listCompanyData: companySelector.getListCompany,
  lobCreate: lobSelector.getCreateLOBData,
  lobEdit: lobSelector.getEditLOBData,
  lobGet: lobSelector.getLOBData,
  lobList: lobSelector.getListLOB,
  lobDeactivate: lobSelector.getDeactivateLOBData,
  exportURL: lobSelector.getExportURL,
  employeeList: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  createLOB: lobAction.createLOB,
  resetCreateLOB: lobAction.resetCreateLOB,
  resetEditLOB: lobAction.resetEditLOB,
  resetDeactivateLOB: lobAction.resetDeactivateLOB,
  listCompany: companyAction.getCompany,
  listEmployee: employeeAction.getUser,
  listLOB: lobAction.getLOB,
  exportLOB: lobAction.exportLOB,
  resetExportLOB: lobAction.resetExportLOB,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(LOBPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/lob/index.js